// extracted by mini-css-extract-plugin
module.exports = {"root":"CtaSection_root__tLia8","content":"CtaSection_content__SzYvt","stacked":"CtaSection_stacked__l5XHN","text":"CtaSection_text__suAIq","inline":"CtaSection_inline__Ogmir"};